/**
 * Build an iframe HTML string for embedding media.
 *
 * @param {string} embedUrl - Full URL to the /embed endpoint
 * @param {object} options
 * @param {string} [options.type='video'] - 'video' or 'audio'
 * @param {boolean} [options.fullWidth=true] - Use full-width (true) or constrained (false)
 * @returns {string} iframe HTML
 */
export function buildEmbedIframe(
  embedUrl,
  { type = 'default', width = 640, height = 360 } = {},
) {
  const EMBED_HTML = {
    default: `<div style="position:relative;width:100%;max-width:960px;">
  <div style="padding-top:56.25%;"></div>
  <iframe
    src="${embedUrl}&type=video"
    title="Moniviestin media player"
    frameborder="0"
    allowfullscreen
    loading="lazy"
    style="position:absolute;inset:0;width:100%;height:100%;border:0;"
  ></iframe>
</div>`,
    fullWidth: `<div style="position:relative;width:100%;">
  <div style="padding-top:56.25%;"></div>
  <iframe
    src="${embedUrl}&type=video"
    title="Moniviestin media player"
    frameborder="0"
    allowfullscreen
    loading="lazy"
    style="position:absolute;inset:0;width:100%;height:100%;border:0;"
  ></iframe>
</div>`,
    audioOnly: `<iframe
  src="${embedUrl}&type=audio"
  width="${width}" height="${height}"
  style="aspect-ratio:16/8; max-width:850px; width:100%; border:none; border-radius: 25px; display: block; margin-top: 5px; margin-bottom: 5px;" 
  allowfullscreen
></iframe>`,
  };

  return EMBED_HTML[type];
}
